import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>404 - Page Not Found</h1>
            <p style={styles.message}>
                Oops! The page you're looking for doesn't exist.
            </p>
            <Link to="/dashboard" style={styles.link}>
                Go back to the dashboard page
            </Link>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        textAlign: 'center',
        padding: '50px',
    },
    heading: {
        fontSize: '2rem',
        color: '#333',
    },
    message: {
        fontSize: '1rem',
        color: '#666',
    },
    link: {
        fontSize: '1rem',
        color: '#007BFF',
        textDecoration: 'none',
    },
};

export default NotFound;